import { ViewModel, View, ObservableArray, ViewModelMessage } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { DragDropPossibilityChecker, DropAppliedViewModelMessage } from "uicomponents";
import { AccountSelectorViewModel } from "../accountSelector/accountSelector-viewModel";
import { DistinguishingDetailDefinitionViewModel, DistinguishingDetailWrapper } from "../distinguishingDetailDefinition/distinguishingDetailDefinition-viewModel";
import { AccountDefinitionView } from "./accountDefinition-view"
import { translate } from "src/common/utilities";

export class AccountDefinitionViewModel extends WindowViewModel implements IAccountContainer {
    public getTitle(): string {
        return translate("accountDefinition-viewModel.accountDefinition", {});
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.detailDefinition = new DistinguishingDetailDefinitionViewModel(this);
        this.rootAccounts = ObservableArray.create<SingleAccount>();

        this.refresh();
    }

    GetDefaultView(): View<ViewModel> {
        return new AccountDefinitionView();
    }
    public getTypeId(): string {
        return "VM-8E079291-B50C-414B-882B-7FAEBFE16A0A"
    }

    public set detailDefinition(v: DistinguishingDetailDefinitionViewModel) { this._detailDefinition = v; } public get detailDefinition(): DistinguishingDetailDefinitionViewModel { return this._detailDefinition; } private _detailDefinition: DistinguishingDetailDefinitionViewModel;
    public set rootAccounts(v: ObservableArray<SingleAccount>) { this._rootAccounts = v; } public get rootAccounts(): ObservableArray<SingleAccount> { return this._rootAccounts; } private _rootAccounts: ObservableArray<SingleAccount>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    convertAccountDto(dto: any[], parent: ViewModel, parentAccount: SingleAccount): SingleAccount[] {
        return dto.map(x => {
            let r = new SingleAccount(parent, parentAccount);
            r.id = x.Id;
            r.name = x.Name;
            r.code = x.Code;
            r.details.update(...x.DistinguishingDetails.map(q => {
                let d = new DistinguishingDetail(r);
                d.id = q.Id;
                d.name = q.AssignmentName;
                d.typeName = q.Name;
                d.canEdit = false;
                return d;
            }));
            r.children.update(...this.convertAccountDto(x.ChildAccounts, r, r));
            r.children.sort((a, b) => parseInt(a.code) - parseInt(b.code))
            return r;
        });
    }
    async refresh() {
        try {
            this.isLoading = true;
            let dtoResult = await ServerConnection.callServer('Complex/AccountingServices/GetAllAccounts', {});
            this.rootAccounts.update(...this.convertAccountDto(dtoResult.Accounts, this, null));
            this.rootAccounts.sort((a, b) => parseInt(a.code) - parseInt(b.code))
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    private getAccountsDtos(node: SingleAccount[]) {
        return node.map(x => {
            return {
                AccountId: x.id,
                Name: x.name,
                Code: x.code,
                Details: x.details.map(q => {
                    return {
                        DetailId: q.id,
                        Name: q.name,
                        ClientProvidedId: q.clientProvidedId
                    }
                }),
                ChildAccounts: this.getAccountsDtos(x.children)
            }
        })
    }
    async save() {
        try {
            this.isLoading = true;
            let detailDtos = this.detailDefinition.getUpdateDto();
            await ServerConnection.callServer('Complex/AccountingServices/UpdateAccountDefinitionInfo', {
                AtomicDetails: detailDtos.AtomicDetails,
                ComplexDetails: detailDtos.ComplexDetails,
                Accounts: this.getAccountsDtos(this.rootAccounts)
            });
            this.messageBoxConfirmSuccess(translate("accountDefinition-viewModel.successfullyUpdated", {}), translate("accountDefinition-viewModel.successfulOperation", {}));
            this.refresh();
        } catch (ex) {
            console.log(ex);
            this.messageBoxConfirmWarning(translate("accountDefinition-viewModel.errorInUpdate", {}), translate("accountDefinition-viewModel.error", {}))
        } finally {
            this.isLoading = false;
        }
    }
    handleMessage(message: ViewModelMessage) {
        if (message instanceof DragDropPossibilityChecker &&
            message.dragged instanceof SingleAccount &&
            message.droppedTo instanceof SingleAccount) {
            if (message.droppedTo.isChildOf(message.dragged)) {
                return message.createRejectResponse();
            } else {
                return message.createAllowanceResponse("Allowed");
            }
        } else if (message instanceof DragDropPossibilityChecker &&
            message.dragged instanceof DistinguishingDetailWrapper &&
            message.droppedTo instanceof SingleAccount) {
            return message.createAllowanceResponse("Allowed");
        } else if (message instanceof DropAppliedViewModelMessage &&
            message.dragged instanceof SingleAccount &&
            message.droppedTo instanceof SingleAccount) {
            if (message.droppedTo.isChildOf(message.dragged)) {
            } else {
                message.dragged.changeParent(message.droppedTo);
            }
            return null;
        } else if (message instanceof DropAppliedViewModelMessage &&
            message.dragged instanceof DistinguishingDetailWrapper &&
            message.droppedTo instanceof SingleAccount) {
            message.droppedTo.addDetail(message.dragged);
            return null;

        } else {
            return super.handleMessage(message)
        }
    }
    addAccount() {
        let newAccount = new SingleAccount(this, null);
        this.rootAccounts.push(newAccount);
    }

    removeChlidAccount(account: SingleAccount) {
        this.rootAccounts.remove(account);
    }
}

export class SingleAccount extends ViewModel implements IAccountContainer {
    addDetail(newDetail: DistinguishingDetailWrapper) {
        let detail = new DistinguishingDetail(this);
        detail.account = this;
        detail.clientProvidedId = newDetail.index;
        detail.id = newDetail.id;
        detail.name = '';
        detail.typeName = newDetail.name;
        detail.canEdit = true;
        this.details.push(detail);
    }

    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }

    constructor(parent: ViewModel, parentAccount: SingleAccount) {
        super(parent);
        this.children = ObservableArray.create<SingleAccount>();
        this.details = ObservableArray.create<DistinguishingDetail>();
        this.parentAccount = parentAccount;
        this.parentAccountContainer = <IAccountContainer><any>parent;
        this.isShowingMenu = false;
    }
    private parentAccountContainer: IAccountContainer;
    private parentAccount: SingleAccount;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set children(v: ObservableArray<SingleAccount>) { this._children = v; } public get children(): ObservableArray<SingleAccount> { return this._children; } private _children: ObservableArray<SingleAccount>;
    public set details(v: ObservableArray<DistinguishingDetail>) { this._details = v; } public get details(): ObservableArray<DistinguishingDetail> { return this._details; } private _details: ObservableArray<DistinguishingDetail>;
    public set isShowingMenu(v: boolean) { this._isShowingMenu = v; } public get isShowingMenu(): boolean { return this._isShowingMenu; } private _isShowingMenu: boolean;


    changeParent(newParent: SingleAccount) {
        this.delete();
        newParent.addNewChildAccount(this);
    }
    addNewChildAccount(newChild: SingleAccount) {
        newChild.parentAccountContainer = this;
        newChild.parentAccount = this;
        this.children.push(newChild);
    }


    isChildOf(parent: SingleAccount): boolean {
        if (this == parent)
            return true;
        if (this.parentAccount == null)
            return false;
        else
            return this.parentAccount.isChildOf(parent);
    }
    removeDetail(detail: DistinguishingDetail) {
        this.details.remove(...[detail]);
    }

    addChlidAccount() {
        let newAccount = new SingleAccount(this, this);
        this.children.push(newAccount);
    }
    removeChlidAccount(account: SingleAccount) {
        this.children.remove(account);
    }

    delete() {
        this.parentAccountContainer.removeChlidAccount(this);
    }
}
export class DistinguishingDetail extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    public set account(v: SingleAccount) { this._account = v; } public get account(): SingleAccount { return this._account; } private _account: SingleAccount;

    constructor(parent: SingleAccount) {
        super(parent);
        this.account = parent;
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set typeName(v: string) { this._typeName = v; } public get typeName(): string { return this._typeName; } private _typeName: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set clientProvidedId(v: number) { this._clientProvidedId = v; } public get clientProvidedId(): number { return this._clientProvidedId; } private _clientProvidedId: number;

    public set canEdit(v: boolean) { this._canEdit = v; } public get canEdit(): boolean { return this._canEdit; } private _canEdit: boolean;

    remove() {
        this.account.removeDetail(this);
    }
}

interface IAccountContainer {
    removeChlidAccount(account: SingleAccount);
}